import { AxiosRequestConfig } from 'axios';

import type { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseCartApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const postToHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
  data?: unknown,
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    let apiUrl = baseCartApiUrl;
    if (remainingPath === '') apiUrl = apiUrl.replace('external/', 'external');

    return (
      await hamsClient.post(`${apiUrl}${remainingPath}`, data, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
